import { motion } from "framer-motion";

export const KineticLine = ({ children, delay = 0, className = "", as: Tag = "span" }) => (
  <span className={`block overflow-hidden pb-[0.08em] -mb-[0.08em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ y, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs font-medium uppercase tracking-[0.25em] text-terracotta ${className}`}
  >
    <span className="h-px w-8 bg-terracotta" aria-hidden="true" />
    {children}
  </span>
);
